import { render, staticRenderFns } from "./currency-rates.vue?vue&type=template&id=34ee69ba"
import script from "./currency-rates.ts?vue&type=script&lang=ts&external"
export * from "./currency-rates.ts?vue&type=script&lang=ts&external"
import style0 from "./currency-rates.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ee69ba')) {
      api.createRecord('34ee69ba', component.options)
    } else {
      api.reload('34ee69ba', component.options)
    }
    module.hot.accept("./currency-rates.vue?vue&type=template&id=34ee69ba", function () {
      api.rerender('34ee69ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rates-dashboard/currency-rates/currency-rates.vue"
export default component.exports